import { IDENTIFIER } from "../../utils/enums";

// MODIFIED: Added 'allowNone' prop and updated logic for value styling
export function IdentifierSelect({ 
  value, 
  setValue, 
  includeAll = false,
  allowNone = false,
  darkAllValue = false 
}) { 
  const handleSelectChange = (event) => {
    setValue(event.target.value);
  };

  // Determine if the current value is the 'None' or 'All' empty string value
  const isNoneOrAllSelected = value === "" || value === undefined; 

  return (
    <div>
      <select 
        id="identifier-select" 
        value={value || ""} 
        onChange={handleSelectChange} 
        // MODIFIED: Style conditionally based on whether a meaningful value is selected or if it's 'None'/'All'
        style={{ color: value || darkAllValue ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}
      >
        {/* CONDITIONAL RENDERING FOR 'All' OPTION (For Filters) */}
        {includeAll && (
          <option value="">All</option>
        )}
        {/* If not including 'All', show placeholder, UNLESS 'allowNone' is true */}
        {!includeAll && !allowNone && (
            <option value="" disabled hidden>Choose Identifier</option>
        )}
        
        {/* ADDED: Conditional Rendering for 'None' Option (For Add/Edit Forms) */}
        {allowNone && (
          <option value="">None</option>
        )}
        {/* END CONDITIONAL RENDERING */}
        
        <option value={IDENTIFIER.FIRST}>{IDENTIFIER.FIRST}</option>
        <option value={IDENTIFIER.SECOND}>{IDENTIFIER.SECOND}</option>
      </select>
    </div>
  );
}